import { render, staticRenderFns } from "./ComposicaoDoRebanhoMedioPorUaPercentual.vue?vue&type=template&id=78c4b3de&scoped=true&"
import script from "./ComposicaoDoRebanhoMedioPorUaPercentual.vue?vue&type=script&lang=js&"
export * from "./ComposicaoDoRebanhoMedioPorUaPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4b3de",
  null
  
)

export default component.exports